/**
 * Minimal className joiner (clsx-lite). Kept dependency-free for the mock.
 * Swap for `clsx` + `tailwind-merge` if class conflict resolution is needed.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
    return classes.filter(Boolean).join(' ');
}
